import { SagaIterator } from 'redux-saga';
import { all, call, put, takeLatest } from 'redux-saga/effects';
import * as branchService from '../../services/branchAPI';
import { fetchBranchListFailure, fetchBranchListSuccess } from './actions';
import { FETCH_BRANCH_LIST_REQUEST } from './actionTypes';
import { IFetchBranchListRequest } from './types';

export function* fetchBranchList({
  chiefdomId,
  successCb,
  failureCb
}: IFetchBranchListRequest): SagaIterator {
  try {
    const {
      data: { entity: list, totalCount: total }
    } = yield call(branchService.fetchBranchesByLocation as any, chiefdomId);
    const payload = { branchList: list, total };
    successCb?.(payload);
    yield put(fetchBranchListSuccess(payload));
  } catch (e) {
    if (e instanceof Error) {
      failureCb?.(e);
      yield put(fetchBranchListFailure(e));
    }
  }
}

function* branchSaga() {
  yield all([takeLatest(FETCH_BRANCH_LIST_REQUEST, fetchBranchList)]);
}

export default branchSaga;
